import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GkComponentsModule, GkMapModule } from '@gk/gk-modules';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared/shared.module';
import { createTranslateLoader } from '../address-number-request-portal/address-number-request-portal.module';
import { BuildingPermitModificationDecisionRoutingModule } from './building-permit-modification-decision-routing.module';
import { BPMDNewRequestComponent } from './new-request/new-request.component';
import { BPMDNewRequestFormService } from './services/new-request-form/new-request-form.service';

@NgModule({
  declarations: [BPMDNewRequestComponent],
  imports: [
    SharedModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    GkMapModule,
    GkComponentsModule,
    BuildingPermitModificationDecisionRoutingModule,
  ],
  providers: [BPMDNewRequestFormService],
})
export class BuildingPermitModificationDecisionModule {}
